// Inline checkbox + label. Use when the boolean fits on one row alongside
// other inputs; for top-level switches prefer a dedicated Section + this.

interface BooleanFieldProps {
  label: string;
  hint?: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}

export function BooleanField({ label, hint, checked, onChange, disabled }: BooleanFieldProps) {
  return (
    <label className="flex items-start gap-2 text-[13px] leading-tight">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-[color:var(--bo-line)]"
      />
      <span className="flex flex-col">
        <span className="text-[color:var(--bo-ink)]">{label}</span>
        {hint ? (
          <span className="text-[11.5px] text-[color:var(--bo-mute)]">{hint}</span>
        ) : null}
      </span>
    </label>
  );
}
